import Model from "./Model.js";

/**
 * Encapsulate a report showing specs from different sources. This is
 * used to compare values from actuals, forecast estimates, and
 * budgets for various periods.
 *
 * @param {Report} report - Report specific to the current comparison
 *   tool
 */
export default class ComparisonReport extends Model {
	constructor({ report }) {
		super(...arguments);

		this._report = report;
	}

	/**
	 * Visiting method.  See `reportVisitor` for all visiting methods.
	 */
	accept(visitor) {
		return visitor.visitComparisonReport(this);
	}

	hasSummaryRow(...rest) {
		return this._report.hasSummaryRow(...rest);
	}

	getColumns() {
		return this._report.getColumns();
	}

	getVisibleRows() {
		return this._report.getVisibleRows();
	}

	getVisibleColumns() {
		return this._report.getVisibleColumns();
	}

	getLeafColumns() {
		return this._report.getLeafColumns();
	}

	getSerializableLeafColumns() {
		return this._report.getSerializableLeafColumns();
	}

	getLeafVisibleColumns() {
		return this._report.getLeafVisibleColumns();
	}

	getTitle() {
		return this._report.getTitle();
	}

	getTitleString() {
		return this._report.getTitleString();
	}

	withCoALanguage(...rest) {
		return this._report.withCoALanguage(...rest);
	}
}
